import Chip from '@mui/material/Chip'
import { themeConfig } from '@gap/shared/theme'
import { gapPassionPalette } from 'theme/theme'

type ColorVariant = 'accent' | 'success' | 'info' | 'warning' | 'error' | 'primary' | 'secondary' | 'announcement' | 'accepted' | 'draft' | 'overdue' | 'sent' | 'archived' | 'demo'

interface GapChipProps extends Omit<React.ComponentProps<typeof Chip>, 'color' | 'size'> {
   colorVariant: ColorVariant
   label: string
}

const getColorVariants = (chipVariant: ColorVariant) => {
   switch (chipVariant) {
      case 'success':
         return {
            background: themeConfig.system.success[200],
            text: themeConfig.system.success[900]
         }
      case 'info':
         return {
            background: themeConfig.system.info[200],
            text: themeConfig.system.info[900]
         }
      case 'warning':
         return {
            background: themeConfig.system.warning[200],
            text: themeConfig.system.warning[900]
         }
      case 'error':
         return {
            background: themeConfig.system.error[200],
            text: themeConfig.system.error[900]
         }
      case 'primary':
         return {
            background: themeConfig.primary[900],
            text: gapPassionPalette.contrastText
         }
      case 'accent':
         return {
            background: themeConfig.accents.violet[300],
            text: themeConfig.accents.violet[900],
         }
      case 'secondary':
         return {
            background: themeConfig.primary[800],
            text: gapPassionPalette.contrastText
         }
      case 'announcement':
         return {
            background: themeConfig.passion,
            text: gapPassionPalette.contrastText
         }
      case 'accepted':
         return { background: themeConfig.system.success[300], text: themeConfig.system.success[900] }
      case 'draft':
         return { background: themeConfig.system.info[300], text: themeConfig.system.info[900] }
      case 'overdue':
         return { background: themeConfig.accents.orange[300], text: themeConfig.accents.orange[900] }
      case 'sent':
         return { background: themeConfig.accents.yellow[300], text: themeConfig.accents.yellow[900] }
      case 'archived':
         return { background: themeConfig.grey[400], text: themeConfig.grey[800] }
      case 'demo':
         return { background: themeConfig.accents.yellow[300], text: themeConfig.accents.yellow[900] }
   }
}

export default function GapChip({
   colorVariant,
   label,
   ...chipProps
}: GapChipProps) {
   const chipVariants = getColorVariants(colorVariant)

   return (
      <Chip
         {...chipProps}
         label={label}
         size="small"
         sx={{
            backgroundColor: chipVariants.background,
            color: chipVariants.text,
            '& .MuiChip-label': {
               color: chipVariants.text
            },
            ...chipProps.sx
         }}
      />
   )
}

